import { setWeightCaptureResponse } from "~/features/autostorePicking/autostorePicking.slice";
import {
  CaptureWeightRequest,
  CaptureWeightResponse,
  GetCapturedWeightStateRequest,
  GetCapturedWeightStateResponse,
  CompletePickRequest,
  PickDto,
  RejectWeightRequest,
  RejectWeightResponse,
  SplitPickRequest,
  SplitPickResponse
} from "~/types/api";

import { warehouseApi } from "./warehouseApi";

export const pickApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    getPick: build.query<PickDto, Guid>({
      query: (pickId) => ({
        url: `/picks/${pickId}`,
        method: "GET"
      }),
      providesTags: ["pick"]
    }),
    getPicks: build.query<PickDto[], { orderId: Guid }>({
      query: ({ orderId }) => ({
        url: "/picks",
        method: "GET",
        params: {
          orderId
        }
      }),
      providesTags: ["pick"]
    }),
    captureWeight: build.mutation<CaptureWeightResponse, CaptureWeightRequest>({
      query: (body) => ({
        url: "/picks/capture-weight",
        method: "POST",
        body
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setWeightCaptureResponse(data));
        } catch {
          // Error is handled by the caller via unwrap()
        }
      }
    }),
    rejectWeight: build.mutation<RejectWeightResponse, RejectWeightRequest>({
      query: (body) => ({
        url: "/picks/reject-weight",
        method: "POST",
        body
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setWeightCaptureResponse(data));
        } catch {
          // Error is handled by the caller via unwrap()
        }
      }
    }),
    getCapturedWeightState: build.mutation<
      GetCapturedWeightStateResponse,
      GetCapturedWeightStateRequest
    >({
      query: (request) => ({
        url: `/picks/get-captured-weight-state`,
        method: "POST",
        body: request
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setWeightCaptureResponse(data));
        } catch {
          // Error is handled by the caller via unwrap()
        }
      }
    }),
    verifyPick: build.mutation<
      void,
      {
        upcOrSku: string;
        pickId: string;
        verifyMethod: string;
        workstationId: string | undefined;
      }
    >({
      query: ({ upcOrSku, pickId, verifyMethod, workstationId }) => {
        const request = { upcOrSku, pickId, verifyMethod, workstationId };

        return {
          url: "/picks/verify",
          method: "POST",
          body: request
        };
      }
    }),
    completePick: build.mutation<void, CompletePickRequest>({
      query: (body) => {
        return {
          url: "/picks/complete",
          method: "POST",
          body
        };
      },
      invalidatesTags: ["tote"]
    }),
    splitPick: build.mutation<SplitPickResponse, SplitPickRequest>({
      query: (body) => {
        return {
          url: "/picks/split",
          method: "POST",
          body
        };
      },
      // consider moving this to autostore picking API and invalidating the focused pick
      invalidatesTags: ["pick", "focused pick"]
    })
  }),
  overrideExisting: false
});
